import { UseMutationResult } from '@tanstack/react-query';

import { getLateResponsesReportCsv, useBaseReportCsv } from 'api';

export const useLateResponsesReportCsv = (): UseMutationResult<Blob> =>
  useBaseReportCsv(getLateResponsesReportCsv);
